import React from "react";
import { Text } from "../Info/Info.styled";

function Footer() {
  return <Text>Danilova Valentina, 2023</Text>;
}

export default Footer;
